import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { withRouter } from "react-router-dom";
import Search from "@material-ui/icons/Search";
import { get } from "lodash";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { MenuItem, Select } from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import CircularProgress from "@material-ui/core/CircularProgress";

import { generateDate, getOrderDetailsPath, toLower } from "../../utils/utils";
import { roles } from "../../constants/roles";
import { fetchGet } from "../../api/fetch";
import OrderPopup from "./OrderPopup";
import colors from "../../assets/style/colors";
import store from "../../index";
import MobileOrderRow from "./MobileOrderRow";

const styles = {
  mainContent: {
    width: "calc(100vw - 124px)",
    height: "calc(100vh - 200px)",
    minHeight: 0,
    margin: "24px",
    padding: "24px",
  },
  container: {
    height: "40px",
    width: "100%",
    backgroundColor: colors.white,
    paddingLeft: "24px",
    boxShadow: `0px 0px 4px 0px ${colors.black23}`,
  },
  //ORDERS
  scanProduct: {
    height: "709px",
    width: "414px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#f3f3f3",
    border: "1px solid #dddddd"
  },
  scanProductHeader: {
    width: "100%",
    height: "50px",
    display: "flex",
    justifyContent: "center"
  },
  scanProductNav: {
    width: "100%",
    height: "50px",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  scanProductStructure: {
    width: "100%",
    height: "50px",
    display: "flex",
    alignItems: "center",
    fontSize: "18px",
    paddingLeft: "8px",
    boxSizing: "border-box",
  },
  scanProductItem: {
    width: "406px",
    height: "161px",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
    borderRadius: "3px",
    padding: "8px",
    boxSizing: "border-box",
    marginBottom: "8px",
    filter: "drop-shadow(0px 2px 2px #00000044)"
  },
  itemTitle: {
    fontSize: "20px",
  },
  itemCodeContainer: {
    display: "flex",
    marginBottom: "16px",
  },
  itemPicture: {
    width: "70px",
    height: "30px",
    backgroundColor: "lightblue",
    marginBottom: "24px",
  },
  itemDetails: {
    fontSize: "18px",
    marginBottom: "8px",
  },
  scanProductOrder: {
    width: "406px",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
    borderRadius: "3px",
    padding: "8px",
    boxSizing: "border-box",
    filter: "drop-shadow(0px 2px 2px #00000044)"
  },
  scanProductBin: {
    width: "366px",
    height: "133px",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
  },
  binDetails: {
    margin: "8px 0px",
    "& span": {
      color: "rgba(0,0,0,0.54)",
      marginRight: "24px",
    }
  },
  deliveryDetails: {
    color: "#eb3c39",
  },
  orderOptions: {
    margin: "16px 0 56px 0",
    fontSize: "18px",
    display: "flex"
  },
  orderFillingContainer: {
    marginBottom: "58px"
  },
  orderFilling: {
    display: "flex",
    justifyContent: "space-between",
    "& button": {
      fontSize: "20px",
      width: "114px",
      height: "44px",
      border: "1px solid black",
      borderRadius: "3px",
      boxSizing: "border-box",
      backgroundColor: "white",
    }
  },
  orderProductQty: {
    height: "23px",
    display: "flex",
    justifyContent: "center",
    marginBottom: "8px"
  },
  productQty: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& span": {
      paddingLeft: "4px",
      fontSize: "20px"
    }
  },
  confirmBtn: {
    width: "122px",
    height: "36px",
    backgroundColor: "#5f00a0",
    borderRadius: "5px",
    border: "none",
    color: "white"
  },
  // TABLE STYLING
  superTableContainer: {
    height: "605px",
    overflow: "auto",
    "& table": {
      borderCollapse: "separate",
      tableLayout: "fixed",
    },
    "& table thead": {
      '@media(max-width: 470px) ': {
        display: "none",
      }
    },
    "& table thead tr": {
      backgroundColor: "white",
      height: "70px"
    },
    "& table thead tr th": {
      backgroundColor: "#e5f4f6",
      position: "sticky",
      top: "0px",
      zIndex: "1",
    },
    "& table thead tr th:not(:last-child)": {
      borderRight: "3px solid white",
      backgroundClip: "padding-box",
      boxSizing: "border-box",
    },
    "& table tbody tr td": {
      height: "50px",
      color: "rgba(0, 0, 0, 0.54)",
      paddingLeft: "12px",
      cursor: "pointer",
    },
    "& table tbody tr": {
      '@media(max-width: 470px)': {
        display: "grid",
        gridTemplateColumns: "1fr 20px",
        gridTemplateRows: "18px 18px",
        rowGap: "2px",
        width: "100%",
        padding: "8px 0",
        "& td": {
          height: "16px",
          padding: "0",
          boxSizing: "border-box",
          display: "flex",
        },
      }
    },
    '@media(max-width: 470px)': {
      width: "100%",
    }
  },
  tableMain: {
    height: "100%",
    maxWidth: "1396px",
  },
  tableContainer: {
    width: "100%",
    height: "calc(100% - 20.016px - 42px)",
    "& table": {
      borderCollapse: "separate",
      tableLayout: "fixed",
    },
    "& table thead tr": {
      backgroundColor: "white",
      height: "70px"
    },
    "& table thead tr th": {
      backgroundColor: "#e5f4f6",
      position: "sticky",
      top: "0px",
      zIndex: "1",
    },
    "& table thead tr th:not(:last-child)": {
      borderRight: "3px solid white",
      backgroundClip: "padding-box",
      boxSizing: "border-box",
    },
    "& table tbody tr td": {
      height: "50px",
      color: "rgba(0, 0, 0, 0.54)",
      paddingLeft: "12px",
      cursor: "pointer",
    },
  },
  tableAdmin: {
    width: "calc(170px + 210px + 195px + 185px + 270px + 88px + 170px + 216px + 170px + 170px + 600px)",
  },
  tableClient: {
    width: "calc(170px + 210px + 195px + 185px + 270px + 88px + 170px + 216px + 170px + 170px)",
  },
  evenRow: {
    backgroundColor: "#f8f8f8",
  },
  tableOrderNo: {
    width: "170px",
  },
  tableCompany: {
    width: "210px",
  },
  tableSite: {
    width: "195px",
  },
  tableSector: {
    width: "185px",
  },
  tableVMI: {
    width: "270px",
  },
  tableProductsQty: {
    width: "88px",
  },
  tableStatus: {
    width: "170px",
  },
  tableExternalRef: {
    width: "216px",
  },
  tableCreatedBy: {
    width: "170px",
  },
  tableCreatedOn: {
    width: "170px",
  },
  tableMessage: {
    width: "600px",
  },
  tableSubtitle: {
    width: "100%",
    padding: "0 12px",
    textAlign: "left",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
  },
  inputContainer: {
    padding: "0 12px",
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
  },
  blueText: {
    color: "#5f00a0",
    cursor: "pointer",
  },
  grayWarningText: {
    color: "rgba(0,0,0,0.54)",
    fontStyle: "italic",
    marginRight: "16px"
  },
  popupHover: {
    display: "inline-block",
    minWidth: "24px",
    height: "24px",
    textAlign: "center",
    padding: "2px 4px 0px",
    "&:hover": {
      borderRadius: "2px",
      cursor: "pointer",
      backgroundColor: "#e5f4f6",
    }
  },
  searchCodeInput: {
    backgroundColor: "white",
    width: "100%",
    height: "36px",
    paddingLeft: "7px",
  },
  selections: {
    marginLeft: "32px"
  },
  delete: {
    color: "#eb3c39",
    marginLeft: "8px"
  },
  statusBar: {
    height: "24px",
    marginBottom: "6px",
    display: "flex",
    justifyContent: "space-between",
    fontSize: "14px",
  },
  ordersBreakdownStatus: {
    display: "flex",
    marginBottom: "4px",
  },
  statusBarActions: {
    display: "flex",
  },
  actionButtons: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridColumnGap: "16px"
  },
  orderRequestNav: {
    width: "220px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  ctaContainer: {
    display: "flex",
    alignItems: "center",
  },
  draggable: {
    width: 350,
    height: 500,
    backgroundColor: "white",
    zIndex: 100,
    boxShadow: "0px 0px 4px 0px rgb(0 0 0 / 24%)"
  },
  closeIcon: {
    float: "right",
    paddingRight: 15,
    top: -15
  },
  titlePopup: {
    display: "table",
    margin: "0 auto",
    top: 15,
    textTransform: "uppercase",
    fontSize: 15,
    fontWeight: 400
  },
  containerSelector: {
    lineHeight: 40,
    top: 30,
    padding: 10,
    marginLeft: 20
  },
  checkboxcustom: {
    display: "inline-block",
    verticalAlign: "middle",
    marginRight: "10px",
    cursor: "pointer"
  },
  checkboxcustomLabel: {
    display: "inline-block",
    verticalAlign: "middle",
    cursor: "pointer",
    position: "relative"
  },
  cancelConfirm: {
    display: "table",
    margin: "0 auto",
    paddingTop: 10
  },
  tdContent: {
    paddingLeft: "12px",
  },
  productQtyCol: {
    textAlign: "center",
  },
  valueHighlight: {
    fontSize: "20px",
    padding: "0 4px",
  },
  tablePeriod: {
    fontWeight: "500",
  },
  tablePeriodInput: {
    width: "220px",
    height: "36px",
    padding: "10px 12px",
    pointerEvents: "none",
    boxSizing: "border-box",
  },
  smallText: {
    fontSize: "12px",
    padding: "4px 12px",
    wordWrap: "break-word",
  },
  // MOBILE
  dialogPaper: {
    width: "100%",
    maxHeight: "100%",
    maxWidth: "360px",
    margin: 0,
  },
  mobileMain: {
    backgroundColor: "white",
    height: "420px"
  },
  mobileRequests: {
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    overflowY: "scroll",
  },
  productError: {
    backgroundColor: "#fdeceb",
  },
  // PAGINATION
  paginationSection: {
    height: "42px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    '@media(max-width: 470px)': {
      height: "50px",
    }
  },
  paginationMain: {
    height: "100%",
    display: "flex",
    alignItems: "flex-end",
    '@media(max-width: 470px)': {
      flexDirection: "column",
      alignItems: "center",
    }
  },
  paginationLimit: {
    display: "flex",
    alignItems: "flex-end",
  },
  paginationDropdown: {
    marginLeft: "4px",
    marginRight: "16px",
    fontSize: "14px",
    "& > .MuiSelect-select": {
      paddingBottom: "0px"
    },
    "& > .MuiSelect-icon": {
      top: "calc(50% - 11px)"
    }
  },
  countDisplay: {
    width: "140px",
    textAlign: "right",
    '@media(max-width: 470px)': {
      width: "200px",
      fontSize: "12px",
      textAlign: "center",
    }
  },
  pageControl: {
    marginLeft: "40px",
    display: "flex",
    alignItems: "flex-end",
    '@media(max-width: 470px)': {
      width: "340px",
      margin: "0",
      justifyContent: "space-between",
      alignItems: "center",
    }
  },
  pageDisplay: {
    border: "1px solid #757575",
    borderRadius: "2px",
    width: "40px",
    height: "24px",
    boxSizing: "border-box",
    paddingTop: "1px",
    textAlign: "center",
    userSelect: "none",
    '@media(max-width: 470px)': {
      border: "none",
      fontSize: "18px",
      color: "#5f00a0",
      fontWeight: "500",
      paddingTop: "0",
    }
  },
  offsetControl: {
    width: "24px",
    height: "24px",
    cursor: "pointer",
    display: "grid",
    placeItems: "center",
  },
  loadingContainer: {
    width: "100%",
    minHeight: "220px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

const Orders = (props) => {
  const { classes, language } = props;

  const [orders, setOrders] = useState([])
  const [allOrders, setAllOrders] = useState([])
  const [ordersFiltered, setOrdersFiltered] = useState([])
  const [orderInfoDialog, setOpenOrderInfo] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [searchTotal, setSearchTotal] = useState(0)
  const [searchLimit, setSearchLimit] = useState(100)
  const [searchOffset, setSearchOffset] = useState(0)
  const [pagesQuantity, setPagesQuantity] = useState(0)

  const handleOffset = type => {
    if (type === "plus") {
      setSearchOffset(prev => Math.min(prev + searchLimit, Math.max((pagesQuantity - 1) * searchLimit, 0)))
    } else if (type === "minus") {
      setSearchOffset(prev => Math.max(prev - searchLimit, 0))
    } else if (type === "min") {
      setSearchOffset(0)
    } else if (type === "max") {
      setSearchOffset((pagesQuantity - 1) * searchLimit)
    }
  }

  const handleLimitChange = (event) => {
    setSearchLimit(Number(event.target.value));
    setSearchOffset(0)
  };

  const level = get(props, ["userRole", "level"]);

  function getWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
  }

  const handleOrderInfo = order => {
    setSelectedOrder(order)
    setOpenOrderInfo(true)
  }

  const getLanguage = () => {
    let language = get(store.getState(), ["user", "language"]);

    return language
  }

  const loadAllOrders = useCallback(async () => {
    setIsLoading(true)

    try {
      const summary = await fetchGet(getOrderDetailsPath({ vmiIds: props.vmiIds, limit: 1, offset: 0 }))
      const total = Number(get(summary, ["total"], 0))

      if (!total) {
        setAllOrders([])

        return
      }

      const data = await fetchGet(getOrderDetailsPath({ vmiIds: props.vmiIds, limit: total, offset: 0 }))
      setAllOrders(get(data, ["items"], []))
    } catch (error) {
      console.error(error)
      setAllOrders([])
    } finally {
      setIsLoading(false)
    }
  }, [props.vmiIds])

  const refreshOrders = useCallback(() => {
    loadAllOrders()
  }, [loadAllOrders])

  useEffect(() => {
    loadAllOrders()
  }, [loadAllOrders]);

  useEffect(() => {
    const filters = {
      orderNo: toLower(props.filters.orderNo),
      company: toLower(props.filters.company),
      site: toLower(props.filters.site),
      sector: toLower(props.filters.sector),
      VMI: toLower(props.filters.VMI),
      status: toLower(props.filters.status),
      sord: toLower(props.filters.sord),
      createdBy: toLower(props.filters.createdBy),
      createdOn: toLower(props.filters.createdOn),
      message: toLower(props.filters.message),
    }

    const hasFilters = Object.values(filters).some(Boolean)
    const filtered = hasFilters
      ? allOrders.filter(order => {
        if (filters.orderNo && !order.order_id.toString().includes(filters.orderNo)) {
          return false
        }
        if (filters.company && !toLower(order.company_name).includes(filters.company)) {
          return false
        }
        if (filters.site && !toLower(order.site_name).includes(filters.site)) {
          return false
        }
        if (filters.sector && !toLower(order.sector_name).includes(filters.sector)) {
          return false
        }
        if (filters.VMI && !toLower(order.VMI).includes(filters.VMI)) {
          return false
        }
        if (filters.status && !toLower(order.order_status_en).includes(filters.status) && !toLower(order.order_status_fr).includes(filters.status)) {
          return false
        }
        if (filters.sord && !toLower(order.order_customer_order_id).includes(filters.sord)) {
          return false
        }
        if (filters.createdBy && !toLower(order.created_by).includes(filters.createdBy)) {
          return false
        }
        if (filters.createdOn && !toLower(generateDate(order.created_on)).includes(filters.createdOn)) {
          return false
        }
        if (filters.message && !toLower(order.system_message).includes(filters.message)) {
          return false
        }

        return true
      })
      : allOrders

    const total = filtered.length
    const pageCount = total > 0 ? Math.ceil(total / searchLimit) : 0

    setOrdersFiltered(filtered)
    setSearchTotal(total)
    setPagesQuantity(pageCount)

    setSearchOffset(prev => {
      if (pageCount === 0) {
        return 0
      }

      const maxOffset = (pageCount - 1) * searchLimit

      return prev > maxOffset ? maxOffset : prev
    })
  }, [allOrders, props.filters, searchLimit])

  useEffect(() => {
    setOrders(ordersFiltered.slice(searchOffset, searchOffset + searchLimit))
  }, [ordersFiltered, searchOffset, searchLimit])

  return (
    getWidth() > 478 ?
      <>
        <div className={classes.superTableContainer}>
          <Grid item className={`${classes.tableMain}`}>
            <Dialog open={orderInfoDialog} maxWidth={false} onBackdropClick={() => setOpenOrderInfo(false)}>
              <OrderPopup
                order={selectedOrder}
                handleClose={() => setOpenOrderInfo(false)}
                setOrders={refreshOrders}
                setOrdersFiltered={refreshOrders}
                setSearchOffset={setSearchOffset}
                vmiIds={props.vmiIds}
                searchLimit={searchLimit}
                searchOffset={searchOffset}
              ></OrderPopup>
            </Dialog>
            <div className={classes.tableContainer} >
              {isLoading ?
                <div className={classes.loadingContainer}>
                  <CircularProgress size={34} />
                </div>
                :
                <table className={level <= roles.customerAdmin ? classes.tableAdmin : classes.tableClient}>
                  <thead>
                    <tr>
                      <th className={classes.tableOrderNo}>
                        <div className={classes.tableSubtitle}>{I18n.get("order_confirmation_1")}</div>
                        <div className={classes.inputContainer}>
                          <TextField
                            value={props.filters.orderNo || ""}
                            onChange={(e, value) => props.addFilter(e, "orderNo")}
                            variant="outlined"
                            InputProps={{
                              startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                              endAdornment: props.filters.orderNo ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => props.removeFilter("orderNo")}><Close /></InputAdornment> : null,
                              style: { paddingRight: "0px" },
                              className: classes.searchCodeInput,
                            }}
                          />
                        </div>
                      </th>
                      <th className={classes.tableCompany}>
                        <div className={classes.tableSubtitle}>{I18n.get("companies_company")}</div>
                        <div className={classes.inputContainer}>
                          <TextField
                            value={props.filters.company || ""}
                            onChange={(e, value) => props.addFilter(e, "company")}
                            variant="outlined"
                            InputProps={{
                              startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                              endAdornment: props.filters.company ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => props.removeFilter("company")}><Close /></InputAdornment> : null,
                              style: { paddingRight: "0px" },
                              className: classes.searchCodeInput,
                            }}
                          />
                        </div>
                      </th>
                      <th className={classes.tableSite}>
                        <div className={classes.tableSubtitle}>{I18n.get("companies_site")}</div>
                        <div className={classes.inputContainer}>
                          <TextField
                            value={props.filters.site || ""}
                            onChange={(e, value) => props.addFilter(e, "site")}
                            variant="outlined"
                            InputProps={{
                              startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                              endAdornment: props.filters.site ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => props.removeFilter("site")}><Close /></InputAdornment> : null,
                              style: { paddingRight: "0px" },
                              className: classes.searchCodeInput,
                            }}
                          />
                        </div>
                      </th>
                      <th className={classes.tableSector}>
                        <div>
                          <div className={classes.tableSubtitle}>{I18n.get("sector")}</div>
                          <div className={classes.inputContainer}>
                            <TextField
                              value={props.filters.sector || ""}
                              onChange={(e, value) => props.addFilter(e, "sector")}
                              variant="outlined"
                              InputProps={{
                                startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                                endAdornment: props.filters.sector ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => props.removeFilter("sector")}><Close /></InputAdornment> : null,
                                style: { paddingRight: "0px" },
                                className: classes.searchCodeInput,
                              }}
                            />
                          </div>
                        </div>
                      </th>
                      <th className={classes.tableVMI}>
                        <div>
                          <div className={classes.tableSubtitle}>{I18n.get("vmi").toUpperCase()}</div>
                          <div className={classes.inputContainer}>
                            <TextField
                              value={props.filters.VMI || ""}
                              onChange={(e, value) => props.addFilter(e, "VMI")}
                              variant="outlined"
                              InputProps={{
                                startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                                endAdornment: props.filters.VMI ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => props.removeFilter("VMI")}><Close /></InputAdornment> : null,
                                style: { paddingRight: "0px" },
                                className: classes.searchCodeInput,
                              }}
                            />
                          </div>
                        </div>
                      </th>
                      <th className={classes.tableProductsQty}>
                        <div className={classes.tableSubtitle}>{I18n.get("site_products")}</div>
                      </th>
                      <th className={classes.tableStatus}>
                        <div>
                          <div className={classes.tableSubtitle}>{I18n.get("status")}</div>
                          <div className={classes.inputContainer}>
                            <TextField
                              value={props.filters.status || ""}
                              onChange={(e, value) => props.addFilter(e, "status")}
                              variant="outlined"
                              InputProps={{
                                startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                                endAdornment: props.filters.status ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => props.removeFilter("status")}><Close /></InputAdornment> : null,
                                style: { paddingRight: "0px" },
                                className: classes.searchCodeInput,
                              }}
                            />
                          </div>
                        </div>
                      </th>
                      <th className={classes.tableExternalRef}>
                        <div>
                          <div className={classes.tableSubtitle}># {I18n.get("ref_external")}</div>
                          <div className={classes.inputContainer}>
                            <TextField
                              value={props.filters.sord || ""}
                              onChange={(e, value) => props.addFilter(e, "sord")}
                              variant="outlined"
                              InputProps={{
                                startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                                endAdornment: props.filters.sord ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => props.removeFilter("sord")}><Close /></InputAdornment> : null,
                                style: { paddingRight: "0px" },
                                className: classes.searchCodeInput,
                              }}
                            />
                          </div>
                        </div>
                      </th>
                      <th className={classes.tableCreatedBy}>
                        <div>
                          <div className={classes.tableSubtitle}>{I18n.get("order_createdBy")}</div>
                          <div className={classes.inputContainer}>
                            <TextField
                              value={props.filters.createdBy || ""}
                              onChange={(e, value) => props.addFilter(e, "createdBy")}
                              variant="outlined"
                              InputProps={{
                                startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                                endAdornment: props.filters.createdBy ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => props.removeFilter("createdBy")}><Close /></InputAdornment> : null,
                                style: { paddingRight: "0px" },
                                className: classes.searchCodeInput,
                              }}
                            />
                          </div>
                        </div>
                      </th>
                      <th className={classes.tableCreatedOn}>
                        <div>
                          <div className={classes.tableSubtitle}>{I18n.get("order_createdOn")}</div>
                          <div className={classes.inputContainer}>
                            <TextField
                              value={props.filters.createdOn || ""}
                              onChange={(e, value) => props.addFilter(e, "createdOn")}
                              variant="outlined"
                              InputProps={{
                                startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                                endAdornment: props.filters.createdOn ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => props.removeFilter("createdOn")}><Close /></InputAdornment> : null,
                                style: { paddingRight: "0px" },
                                className: classes.searchCodeInput,
                              }}
                            />
                          </div>
                        </div>
                      </th>
                      <th className={classes.tableMessage}>
                        <div>
                          <div className={classes.tableSubtitle}>{I18n.get("message")}</div>
                          <div className={classes.inputContainer}>
                            <TextField
                              value={props.filters.message || ""}
                              onChange={(e, value) => props.addFilter(e, "message")}
                              variant="outlined"
                              InputProps={{
                                startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search onClick={() => console.log(ordersFiltered)} /></InputAdornment>,
                                endAdornment: props.filters.message ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => props.removeFilter("message")}><Close /></InputAdornment> : null,
                                style: { paddingRight: "0px" },
                                className: classes.searchCodeInput,
                              }}
                            />
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders
                      .map((p, i) =>
                        <tr key={`order-${i}-${p.order_id}`} className={` ${(i + 1) % 2 === 0 ? classes.evenRow : ""} ${p.system_message && level <= roles.customerAdmin ? classes.productError : ""}`}>
                          <td className={classes.tableOrderNo}>
                            {p.order_id}
                          </td>
                          <td className={classes.tableCompany} title={p.company_name}>
                            {p.company_name.length > 20 ? p.company_name.slice(0, 20) + "..." : p.company_name}
                          </td>
                          <td className={classes.tableSite} title={p.site_name}>
                            {p.site_name.length > 20 ? p.site_name.slice(0, 20) + "..." : p.site_name}
                          </td>
                          <td className={classes.tableSector} title={p.sector_name}>
                            {p.sector_name.length > 20 ? p.sector_name.slice(0, 20) + "..." : p.sector_name}
                          </td>
                          <td className={classes.tableVMI} title={p.VMI}>
                            {p.VMI.length > 20 ? p.VMI.slice(0, 20) + "..." : p.VMI}
                          </td>
                          <td className={classes.tableProductsQty} >
                            <div onClick={() => handleOrderInfo(p)}>
                              <div className={`${classes.popupHover} ${classes.blueText}`}>
                                {p.product_quantity}
                              </div>
                            </div>
                          </td>
                          <td className={classes.tableStatus} >
                            {getLanguage() === 'en' ? p.order_status_en : p.order_status_fr}
                          </td>
                          <td className={classes.tableExternalRef} >
                            {p.order_customer_order_id}
                          </td>
                          <td className={classes.tableCreatedBy} >
                            {p.created_by}
                          </td>
                          <td className={classes.tableCreatedOn} >
                            {generateDate(p.created_on)}
                          </td>
                          {level <= roles.customerAdmin ?
                            <td className={`${classes.tableOrderNo} ${classes.smallText}`} style={{ overflow: "auto" }} >
                              {p.system_message}
                            </td>
                            : null}
                        </tr>
                      )}
                  </tbody>
                </table>
              }
            </div>
          </Grid>
        </div>
        <div className={classes.paginationSection}>
          <div className={classes.paginationMain}>
            {getWidth() > 470 ?
              <div className={classes.paginationLimit}>
                <div>{`${I18n.get("resultsPerPage")}${language === "en" ? ": " : " : "}`}</div>
                <Select
                  value={searchLimit}
                  onChange={handleLimitChange}
                  className={classes.paginationDropdown}
                  disableUnderline
                >
                  <MenuItem value={100}>100</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                </Select>
              </div>
              : null}
            {orders.length > 0 ? <div className={classes.countDisplay}>{getWidth() < 470 ? <span style={{ marginRight: "16px" }}>Page {(searchOffset / searchLimit) + 1}/{pagesQuantity}</span> : null}{`${1 + searchOffset}-${searchOffset + orders.length} of ${searchTotal}`}</div> : null}
            {pagesQuantity > 0 ?
              <div className={classes.pageControl}>
                <div className={classes.offsetControl} onClick={() => handleOffset("min")}>
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.2209 7.41L12.6409 12L17.2209 16.59L15.8109 18L9.81095 12L15.8109 6L17.2209 7.41Z" fill={getWidth() < 470 ? "#5f00a0" : "black"} fillOpacity={searchOffset === 0 ? "0.2" : "1"} />
                    <rect x="8.84302" y="18" width="2" height="12" transform="rotate(-180 8.84302 18)" fill={getWidth() < 470 ? "#5f00a0" : "black"} fillOpacity={searchOffset === 0 ? "0.2" : "1"} />
                  </svg>
                </div>
                <div className={classes.offsetControl} onClick={() => handleOffset("minus")}>
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.442 7.41L10.862 12L15.442 16.59L14.032 18L8.03202 12L14.032 6L15.442 7.41Z" fill={getWidth() < 470 ? "#5f00a0" : "black"} fillOpacity={searchOffset === 0 ? "0.2" : "1"} />
                  </svg>
                </div>
                <div className={classes.pageDisplay}>{(searchOffset / searchLimit) + 1}</div>
                <div className={classes.offsetControl} onClick={() => handleOffset("plus")}>
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.62195 16.59L13.2019 12L8.62195 7.41L10.0319 6L16.0319 12L10.0319 18L8.62195 16.59Z" fill={getWidth() < 470 ? "#5f00a0" : "black"} fillOpacity={searchOffset === ((pagesQuantity - 1) * searchLimit) ? "0.2" : "1"} />
                  </svg>
                </div>
                <div className={classes.offsetControl} onClick={() => handleOffset("max")}>
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.84302 16.59L11.423 12L6.84302 7.41L8.25302 6L14.253 12L8.25302 18L6.84302 16.59Z" fill={getWidth() < 470 ? "#5f00a0" : "black"} fillOpacity={searchOffset === ((pagesQuantity - 1) * searchLimit) ? "0.2" : "1"} />
                    <rect x="15.2209" y="6" width="2" height="12" fill={getWidth() < 470 ? "#5f00a0" : "black"} fillOpacity={searchOffset === ((pagesQuantity - 1) * searchLimit) ? "0.2" : "1"} />
                  </svg>
                </div>
              </div>
              : null}
          </div>
        </div>
      </>
      :
      <div className={classes.mobileMain}>
        <Dialog open={orderInfoDialog} maxWidth={false} fullWidth classes={{ paper: classes.dialogPaper }} onBackdropClick={() => setOpenOrderInfo(false)}>
          <OrderPopup order={selectedOrder} handleClose={() => setOpenOrderInfo(false)} setOrders={refreshOrders} setOrdersFiltered={refreshOrders} setSearchOffset={setSearchOffset}></OrderPopup>
        </Dialog>
        <div className={classes.mobileRequests}>
          {isLoading ?
            <div className={classes.loadingContainer}>
              <CircularProgress size={30} />
            </div>
            :
            orders.map((p, i) =>
              <MobileOrderRow key={`order-${i}-${p.order_id}`} order={p} handleOrderInfo={handleOrderInfo} />
            )
          }
        </div>
        <div className={classes.paginationSection}>
          <div className={classes.paginationMain}>
            {getWidth() > 470 ?
              <div className={classes.paginationLimit}>
                <div>{`${I18n.get("resultsPerPage")}${language === "en" ? ": " : " : "}`}</div>
                <Select
                  value={searchLimit}
                  onChange={handleLimitChange}
                  className={classes.paginationDropdown}
                  disableUnderline
                >
                  <MenuItem value={100}>100</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                </Select>
              </div>
              : null}
            {orders.length > 0 ? <div className={classes.countDisplay}>{getWidth() < 470 ? <span style={{ marginRight: "16px" }}>Page {(searchOffset / searchLimit) + 1}/{pagesQuantity}</span> : null}{`${1 + searchOffset}-${searchOffset + orders.length} of ${searchTotal}`}</div> : null}
            {pagesQuantity > 0 ?
              <div className={classes.pageControl}>
                <div className={classes.offsetControl} onClick={() => handleOffset("min")}>
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.2209 7.41L12.6409 12L17.2209 16.59L15.8109 18L9.81095 12L15.8109 6L17.2209 7.41Z" fill={getWidth() < 470 ? "#5f00a0" : "black"} fillOpacity={searchOffset === 0 ? "0.2" : "1"} />
                    <rect x="8.84302" y="18" width="2" height="12" transform="rotate(-180 8.84302 18)" fill={getWidth() < 470 ? "#5f00a0" : "black"} fillOpacity={searchOffset === 0 ? "0.2" : "1"} />
                  </svg>
                </div>
                <div className={classes.offsetControl} onClick={() => handleOffset("minus")}>
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.442 7.41L10.862 12L15.442 16.59L14.032 18L8.03202 12L14.032 6L15.442 7.41Z" fill={getWidth() < 470 ? "#5f00a0" : "black"} fillOpacity={searchOffset === 0 ? "0.2" : "1"} />
                  </svg>
                </div>
                <div className={classes.pageDisplay}>{(searchOffset / searchLimit) + 1}</div>
                <div className={classes.offsetControl} onClick={() => handleOffset("plus")}>
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.62195 16.59L13.2019 12L8.62195 7.41L10.0319 6L16.0319 12L10.0319 18L8.62195 16.59Z" fill={getWidth() < 470 ? "#5f00a0" : "black"} fill-opacity={searchOffset === ((pagesQuantity - 1) * searchLimit) ? "0.2" : "1"} />
                  </svg>
                </div>
                <div className={classes.offsetControl} onClick={() => handleOffset("max")}>
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.84302 16.59L11.423 12L6.84302 7.41L8.25302 6L14.253 12L8.25302 18L6.84302 16.59Z" fill={getWidth() < 470 ? "#5f00a0" : "black"} fill-opacity={searchOffset === ((pagesQuantity - 1) * searchLimit) ? "0.2" : "1"} />
                    <rect x="15.2209" y="6" width="2" height="12" fill={getWidth() < 470 ? "#5f00a0" : "black"} fill-opacity={searchOffset === ((pagesQuantity - 1) * searchLimit) ? "0.2" : "1"} />
                  </svg>
                </div>
              </div>
              : null}
          </div>
        </div>
      </div>
  );
};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
    user: state.user,
    userRole: get(state, ["user", "role"]),
    solutionsAccess: get(state, ["user", "solutionsAccess"]),
    permissions: get(state, ["user", "permissions"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(Orders))
);
